
export class AuthResponse {
    constructor(
        public token: string) {
    }
}